module.exports = __webpack_public_path__ + "static/media/cake-played.4bfa2907.png";